import React, { useState } from "react";
import SharedComponents from "@audacia-hq/shared/components";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";
import { Advisory } from "@audacia-hq/shared/models";

import { GET_CONTENT } from "../../graphql/query";
import { Content } from "../../models/content";
import { useLocale } from "../../context/LocaleContext";
import { useFetcher } from "../../hooks/useClientFetcher";
import { acknowledgeAdvisory, getAdvisories } from "../../services/api";

interface Props {
  initialAdvisories: Advisory[];
}

const Advisories: React.FC<Props> = ({ initialAdvisories }) => {
  const { t } = useTranslation(["member", "common"]);
  const language = useLocale();
  const [modal, setModal] = useState(true);
  const [advisories, setAdvisories] = useState<Advisory[]>(initialAdvisories);

  const [_getContent, { data, loading }] = useFetcher<{ content: Content[] }>(
    GET_CONTENT,
    { variables: { locale: language, namespace: "abuse", context: "iv-website" } },
  );

  const acknowledgeAdvisories = async () => {
    try {
      await Promise.all(advisories.map((a) => acknowledgeAdvisory({
        variables: {
          advisoryUid: a.advisoryUid,
        },
      })));
      setAdvisories((await getAdvisories()).data.advisories.data);
    } finally {
      setModal(false);
    }
  };

  return (
    <SharedComponents.AlertModal
      title={t("advisory.preventionModalTitle")}
      open={modal && !(loading || !data)}
      validateLabel={t("advisory.acknowledgeButton")}
      cancelLabel={t("common:close")}
      onClose={() => setModal(false)}
      onValidate={acknowledgeAdvisories}
      disableClosingOverlayEvent
      fullWidth
    >
      {advisories.map((a) => (
        <div key={`prevention-text-${a.type}`} className="mb-8">
          {a?.createdAt && <span className="text-xs text-gray-700">{dayjs(a.createdAt).format("DD/MM/YYYY - HH:mm")}</span>}
          <h2>{t(`advisory.titles.${a.type}`)}</h2>
          {/* eslint-disable-next-line react/no-danger */}
          <div dangerouslySetInnerHTML={{ __html: data?.content?.find((c) => c.key === a.type)?.content }} />
        </div>
      ))}
    </SharedComponents.AlertModal>
  );
};

export default Advisories;
